export const capitalizeFirstLetter = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const pluralSuffix = (amount: number): string =>
  amount === 1 ? '' : 's';

export const convertKebabCaseToCamelCase = (str: string): string =>
  str.replace(/-./g, (x) => x[1].toUpperCase());
